import { useState } from "react";
import { RouterProvider } from "@tanstack/react-router";
import { NavigationProvider } from "@archery-inc/design-system";
import { createAppRouter } from "./router";

export default function App() {
  const [router] = useState(() => createAppRouter());
  return (
    <NavigationProvider
      navigate={(href) => {
        void router.history.push(href);
      }}
    >
      <RouterProvider router={router} />
    </NavigationProvider>
  );
}
